import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import "./App.css";
import logo from './images/Disenosintiulo.png'; // Use the correct path for your logo

import BurnsTreatment from './pages/BurnsTreatment';
import InfectedWounds from './pages/InfectedWounds';
import { DiabeticFeet } from './pages/DiabeticFeet'; // Named import
import IVTherapy from './pages/IVTherapy';
import Stomes from './pages/Stomes';
import PressureUlcers from './pages/PressureUlcers';


import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from 'react-slick'; // Import Slider from react-slick

import adultoMayor from './images/adultomayorflyer.png';
import ivyTherapyFlyer from './images/ivtherapyflyer.png';
import babyFlyer from './images/babyflyer.png';
import proximamente from './images/proximamente.jpeg';

import result1 from './images/resultado1.jpeg';
import result2 from './images/resultado2.jpeg';
import result3 from './images/resultado3.jpeg';
import result4 from './images/resultado4.jpeg';
import result5 from './images/resultado5.jpeg';






function App() {
  const [showDropdown, setShowDropdown] = useState(false);
  const [showPopup, setShowPopup] = useState(true); // Popup visibility state


  const toggleDropdown = (e) => {
    e.preventDefault(); // Prevent the default anchor tag behavior
    setShowDropdown(!showDropdown);
  };

  const closePopup = () => setShowPopup(false);

  useEffect(() => {
    // Automatically open the popup on page load
    setShowPopup(true);
  }, []);


   // Slider settings for the carousel
   const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
  };

  const sliderSettings2 = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
  };

  return (
    <Router>
      <div>

      {showPopup && (
          <div className="popup">
            <div className="popup-content">
              <button className="close-popup" onClick={closePopup}>
                ×
              </button>
              <img src={proximamente} alt="Popup Flyer" />
            </div>
          </div>
        )}

<header className="header">
  <img src={logo} alt="Mogaz Clinic Logo" className="logo" />
  <nav>
    <a href="#contact">Contact</a>
    <a href="#location">Location</a>
    <div className="nav-item">
      <a href="#services" onClick={toggleDropdown}>
        Services
      </a>
      {showDropdown && (
        <ul className="dropdown">
          <li><Link to="/burns-treatment">Burns Treatment</Link></li>
          <li><Link to="/infected-wounds">Infected Wounds</Link></li>
          <li><Link to="/diabetic-feet">Diabetic Feet</Link></li>
          <li><Link to="/iv-therapy">IV Therapy</Link></li>
          <li><Link to="/stomes">Stomes</Link></li>
          <li><Link to="/pressure-ulcers">Pressure Ulcers</Link></li>
        </ul>
      )}
    </div>
    <a href="#gallery">
      
      Gallery</a>
    <a href="#about">Our Team</a>
    <a href="#results">Results</a>
  </nav>
</header>


        <main>
          <section id="services">
            <h2>Our Services</h2>
            <p>We specialize in wounds and stomes care with the utmost professionalism.</p>
          </section>

          <Routes>
  <Route path="/burns-treatment" element={<BurnsTreatment />} />
  <Route path="/infected-wounds" element={<InfectedWounds />} />
  <Route path="/diabetic-feet" element={<DiabeticFeet />} />
  <Route path="/iv-therapy" element={<IVTherapy />} />
  <Route path="/stomes" element={<Stomes />} />
  <Route path="/pressure-ulcers" element={<PressureUlcers />} />
</Routes>

          <section id="contact">
  <h2>Contact Us</h2>
  <ul>
    <li>Phone: +52 644 611 1290</li>
    <li>Email: mogazclinicadhe@gmail.com</li>
    <li>
      <a href="https://www.instagram.com/mogaz_clinica/" target="_blank" rel="noopener noreferrer">
        <i className="fab fa-instagram"></i> Instagram
      </a>
    </li>
    <li>
      <a href="https://www.facebook.com/people/Mogaz-Cl%C3%ADnica-de-Heridas-y-Estomas/61569921377269/?mibextid=JRoKGi" target="_blank" rel="noopener noreferrer">
        <i className="fab fa-facebook"></i> Facebook
      </a>
    </li>
    <li>
      <a href="https://wa.me/526446111290" target="_blank" rel="noopener noreferrer">
        <i className="fab fa-whatsapp"></i> WhatsApp
      </a>
    </li>
    <li>
      <a href="https://t.me/mogazclinic" target="_blank" rel="noopener noreferrer">
        <i className="fab fa-telegram"></i> Telegram
      </a>
    </li>
    <li>
      <a href="sms:+526446111290" target="_blank" rel="noopener noreferrer">
        <i className="fas fa-sms"></i> iMessage
      </a>
    </li>
  </ul>
</section>

<section id="main-content" className="main-content">
  <section id="location" className="location">
    <h2>Our Location</h2>
    {/* Google Maps Embed */}
    <iframe
      width="600"
      height="450"
      frameBorder="0"
      style={{ border: 0 }}
      src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyDGNN6ZAX2qeXewoYK_JMxiEfcc4KOalh4&q=Av.+Paseo+Tijuana+9053,+Zona+Rio+SIMNSA,+Tijuana,+Baja+California+22010`}
      allowFullScreen
    ></iframe>
  </section>

  <section id="results" className="results">
    <h2>Results</h2>
    <p>We take pride in delivering outstanding wound and stoma care. Our patients experience remarkable improvements, and their testimonials reflect our dedication to healing.</p>
    <Slider {...sliderSettings2}>
      <div><img src={result2} alt="Antes 2" /></div>
      <div><img src={result3} alt="Antes 3" /></div>
      <div><img src={result4} alt="Antes 4" /></div>
      <div><img src={result5} alt="Antes 5" /></div>
    </Slider>
  </section>

  <section id="gallery" className="gallery">
    <h2>Gallery</h2>
    <Slider {...sliderSettings}>
      <div><img src={adultoMayor} alt="Image 1" /></div>
      <div><img src={ivyTherapyFlyer} alt="Image 2" /></div>
      <div><img src={babyFlyer} alt="Image 3" /></div>
    </Slider>
  </section>
</section>

          <section id="about">
            <h2>About Mogaz Clinic</h2>
            <p>
              Mogaz Clinic is dedicated to providing top-notch care for wounds and stomes. 
              Our experienced team ensures that you receive personalized and compassionate service.
            </p>
          </section>
        </main>
      </div>
    </Router>
  );
}

export default App;
